// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"9c496101","418":"2dda0b46","480":"c2575374"}[chunkId] + ".js";
};